class StickyHeader extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.stickyEnabled = this.dataset.headerSticky === 'true'
    this.header = document.querySelector('.f-section-header')
    if (this.stickyEnabled) {
      this.initStickyHeader()
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler)
  }

  initStickyHeader() {
    // Store initial header position and height
    this.headerHeight = this.header.offsetHeight
    this.originalPosition = this.header.getBoundingClientRect().top + window.scrollY
    
    // Set initial styles
    this.header.style.width = '100%'
    this.header.style.zIndex = '100'
    
    // Create a placeholder to prevent content jump
    this.placeholder = document.createElement('div')
    this.placeholder.style.height = `${this.headerHeight}px`
    this.placeholder.style.display = 'none'
    this.header.parentNode.insertBefore(this.placeholder, this.header)

    // Bind scroll handler
    this.onScrollHandler = this._onScroll.bind(this)
    window.addEventListener('scroll', this.onScrollHandler, { passive: true })
    
    // Initial check
    this._onScroll()
  }

  _onScroll() {
    requestAnimationFrame(() => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      
      if (scrollTop > this.originalPosition) {
        this._makeSticky()
      } else {
        this._reset()
      }
    })
  }

  _makeSticky() {
    if (!this.isSticky) {
      this.isSticky = true
      
      // Apply sticky styles
      this.header.style.position = 'fixed'
      this.header.style.top = '0'
      this.header.style.left = '0'
      this.header.style.right = '0'
      this.header.style.background = window.getComputedStyle(this.header).backgroundColor
      this.header.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)'
      
      // Show placeholder to prevent content jump
      this.placeholder.style.display = 'block'
    }
  }

  _reset() {
    if (this.isSticky) {
      this.isSticky = false
      
      // Reset styles
      this.header.style.position = ''
      this.header.style.top = ''
      this.header.style.left = ''
      this.header.style.right = ''
      this.header.style.boxShadow = ''
      
      // Hide placeholder
      this.placeholder.style.display = 'none'
    }
  }
}

customElements.define('sticky-header', StickyHeader)